import { IApplicationState } from '../../types/redux';
import { INewReviewReducerState } from '../../reducers/newReview';

export const getNewReviewData = (state: IApplicationState): INewReviewReducerState['data'] => {
  return state.newReview.data;
};
